import enCommon from "./en/common";
import cnCommon from "./cn/common";
import cnTag from "./cn/tag";
import enTag from "./en/tag";

export const cnLang = "zh-CN";
export const enLang = "en";

export default {
  [enLang]: {
    common: enCommon,
    tag: enTag
  },
  [cnLang]: {
    common: cnCommon,
    tag: cnTag
  }
};
